import { TRANSLATION_NAME_SPACES } from 'modules/language-provider/i18n.constants';

export const translationNameSpaces = [
    TRANSLATION_NAME_SPACES.TRANSLATIONS,
    TRANSLATION_NAME_SPACES.FALLBACK_TRANSLATIONS
];

export const ERROR_KEYS = {
    WIDGET_ERROR_TITLE: 'error-page__title',
    WIDGET_ERROR_MESSAGE: 'error-page__something-wrong',
    WIDGET_ERROR_NOT_ELIGIBLE: 'error-page__not-eligible',
    WIDGET_ERROR_UNDERAGE: 'error-page__underage',
    WIDGET_ERROR_INVITE_EXCEEDED_TITLE: 'error-page__invite_exceeded_title',
    WIDGET_ERROR_INVITE_EXCEEDED_DESCRIPTION: 'error-page__invite_exceeded_description'
};

export const SUPPORT_TEXT_KEYS = {
    FAQ: 'support-text',
    FAQ_V2: 'support_contact_baseline',
    NO_FAQ: 'support-text-no-faq',
    FAQ_FORMAT: 'support-format-text'
};
